import React from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../Home/Footer'
import RetailDetails from '../Retail/RetailDetails'

const Retailpage = () => {
    return (
        <div>
            <Navbar />

            <RetailDetails />
            <Footer />


        </div>
    )
}

export default Retailpage